import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1581.17647,1750.58824 C1581.17647,1781.64706 1555.76471,1807.05882 1524.70588,1807.05882 L395.294118,1807.05882 C364.235294,1807.05882 338.823529,1781.64706 338.823529,1750.58824 L338.823529,564.705882 L225.882353,564.705882 L225.882353,1750.58824 C225.882353,1843.99059 301.891765,1920 395.294118,1920 L1524.70588,1920 C1618.10824,1920 1694.11765,1843.99059 1694.11765,1750.58824 L1694.11765,564.705882 L1581.17647,564.705882 L1581.17647,1750.58824 Z M677.647059,1581.17647 L790.588235,1581.17647 L790.588235,677.647059 L677.647059,677.647059 L677.647059,1581.17647 Z M1129.41176,1581.17647 L1242.35294,1581.17647 L1242.35294,677.647059 L1129.41176,677.647059 L1129.41176,1581.17647 Z M1340.62306,338.823529 L1217.06541,2.5243549e-29 L694.599529,2.5243549e-29 L571.267765,338.823529 L0.0112941176,338.823529 L0.0112941176,451.764706 L1920.01129,451.764706 L1920.01129,338.823529 L1340.62306,338.823529 Z M691.324235,338.823529 L773.658353,112.941176 L1138.11953,112.941176 L1220.45365,338.823529 L691.324235,338.823529 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconTrashLine = /*#__PURE__*/function (_Component) {
  _inherits(IconTrashLine, _Component);

  var _super = _createSuper(IconTrashLine);

  function IconTrashLine() {
    _classCallCheck(this, IconTrashLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconTrashLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconTrash",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconTrashLine.displayName = "IconTrashLine";
  return IconTrashLine;
}(Component);

IconTrashLine.glyphName = 'trash';
IconTrashLine.variant = 'Line';
IconTrashLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconTrashLine;
export { IconTrashLine };